class CuddleReel extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[data-cuddle-reel-play]');

    if (!this.video) return;

    this.video.muted = true;
    this.video.playsInline = true;
    this.playButton?.addEventListener('click', this.handlePlay);
    this.video.addEventListener('playing', this.handlePlaying);
    this.video.addEventListener('ended', this.handleEnded);
    this.video.addEventListener('error', this.handleAutoplayBlocked);

    this.tryAutoplay();
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.handlePlay);
    this.video?.removeEventListener('playing', this.handlePlaying);
    this.video?.removeEventListener('ended', this.handleEnded);
    this.video?.removeEventListener('error', this.handleAutoplayBlocked);
  }

  tryAutoplay = async () => {
    try {
      await this.video.play();
    } catch (error) {
      this.handleAutoplayBlocked();
    }
  };

  handlePlay = () => {
    this.tryAutoplay();
  };

  handlePlaying = () => {
    this.classList.add('is-playing');
    this.classList.remove('is-autoplay-blocked');
  };

  handleAutoplayBlocked = () => {
    this.classList.remove('is-playing');
    this.classList.add('is-autoplay-blocked');
  };

  handleEnded = () => {
    if (this.video.loop) return;

    this.handleAutoplayBlocked();
  };
}

if (!customElements.get('cuddle-reel')) {
  customElements.define('cuddle-reel', CuddleReel);
}
